import React from "react";
import {
  ContentSection,
  SectionHeading,
  Paragraph,
  Button,
} from "@vwfs-bronson/bronson-react";
import { sendTan } from "../services/api/tanService";
import { TanAuthentication } from '@vwfs-its/sf-sac-frontend'
import { Output } from '../Text';
import { Analytics } from '../services/analytics';
import { setActualPage, trackInteractionSuccess } from './page.utils';
import { isVtiBOP } from '../common/JourneyType';
import { trackInputTan, trackRequestNewTan, trackSubmitError } from './AuthenticationCodeReqeustPage.tracking';
import { getPrefillData } from '../services/api/prefillFromDataStorage';
import { isEmpty } from 'lodash';
import { mapStorefrontToModel } from '../common/PrefillMapping/PrefillMapping';

class AuthenticationCodeRequestPage extends React.Component<
  AuthenticationCodeRequestPageProps,
  AuthenticationCodeRequestPageState
> {
  constructor(props: AuthenticationCodeRequestPageProps) {
    super(props);

    this.state = {
      tanModalShown: false,
    };
  }

  trackPageTAN = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.pageName()]: 'Continue: Authentication',
        [Analytics.keys.viewChange()]: 'TAN request',
        [Analytics.keys.eventType(0)]: 'pageview',
        [Analytics.keys.eventAction(0)]: 'Success',
        [Analytics.keys.eventType(1)]: 'Application data',
        [Analytics.keys.eventAction(1)]: 'Reloaded',
      }
      Analytics.setTrackingData({...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  defaultTrackingDataExpired = {
    [Analytics.keys.pageName()]: 'Continue: Link expired',
    [Analytics.keys.viewChange()]: 'Continue: Link expired',
  }

  trackPageExpired = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.pageName()]: 'Continue: Link expired',
        [Analytics.keys.viewChange()]: 'Continue: Link expired',
        [Analytics.keys.eventType(0)]: 'pageview',
        [Analytics.keys.eventAction(0)]: 'Success',
      }
      Analytics.setTrackingData({...this.defaultTrackingDataExpired, ...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  trackButton = () => {
    trackInteractionSuccess('Back to Heycar', this.defaultTrackingDataExpired)
  }

  componentDidMount() {
    if (this.props.expired) {
      setActualPage('Continue: Authentication')
      this.trackPageExpired()
    } else {
      setActualPage('Continue: Link expired')
      this.trackPageTAN()
    }
  }

  handleSubmit = () => {
    // sendTan(this.props.transactionId);
    this.setState({ tanModalShown: true });
  };

  handleAbort = () => {
    window.location.href = this.props.prefill.salesChannel.redirectUrl;
    this.trackButton()
  };

  processResponse = async (data: any) => {
    this.props.onTanSuccess(mapStorefrontToModel(data))
  }

  customSendRequestData = (tan: string, transactionId: string, processResponse: any) => {
    trackInputTan()
    return new Promise((resolve, reject) => {
      getPrefillData({ transactionId: transactionId, tanValue: tan })
        .then(
          response => {
            if (!response.data) {
              reject(new Error('MISSING_DATA'))
              return
            }
            if (isEmpty(response.data)) {
              resolve('Invalid TAN')
              return
            }
            const { data } = response
            try {
              processResponse(data)
            } catch (e) {
              reject(e)
            }
            resolve(data)
          },
          error => {
            if (error?.response?.status === 400) {
              resolve('Invalid TAN')
            } else {
              reject(error)
            }
          })
    })
  }

  renderDataExpired = () => {
    const { originSystem } = this.props
    return (
      <ContentSection pageWrap>
        <SectionHeading level="3">
          {Output.resolve(
            "pages.heyCar.authenticationCodeRequest.expired.title"
          )}
        </SectionHeading>
        <Paragraph>
          {Output.resolve(
            "pages.heyCar.authenticationCodeRequest.expired.content"
          )}
        </Paragraph>
        {this.props.prefill?.salesChannel && (
          <Paragraph className="u-text-right">
            <Button onClick={() => this.handleAbort()}>
              {isVtiBOP(originSystem)
                ? Output.resolve(
                "pages.heyCar.authenticationCodeRequest.expired.vti.buttonText")
                : Output.resolve(
                  "pages.heyCar.authenticationCodeRequest.expired.buttonText")
              }
            </Button>
          </Paragraph>
        )}
      </ContentSection>
    );
  };

  renderValidData = () => {
    return (
      <ContentSection pageWrap>
        <SectionHeading level="3">
          {Output.resolve(
            "pages.heyCar.authenticationCodeRequest.validData.title"
          )}
        </SectionHeading>
        <Paragraph>
          {Output.resolve(
            "pages.heyCar.authenticationCodeRequest.validData.info"
          )}
          <br />
          {Output.resolve(
            "pages.heyCar.authenticationCodeRequest.validData.tan"
          )}
          <br />
          {this.props.prefill.mobilePhoneCountryCode}{" "}
          {this.props.prefill.mobilePhoneNumber}
        </Paragraph>
        <Paragraph>
          <Button onClick={() => this.handleSubmit()}>
            {Output.resolve(
              "pages.heyCar.authenticationCodeRequest.validData.buttonText"
            )}
          </Button>
        </Paragraph>
        {this.state.tanModalShown && (
          // <TanModal
          //   shown={this.state.tanModalShown}
          //   transactionId={this.props.transactionId}
          //   onSuccess={this.props.onTanSuccess}
          // />
          <TanAuthentication
            version={1}
            transactionId={this.props.transactionId}
            productName={process.env.REACT_APP_ENTRYPOINT.toUpperCase()}
            visible={this.state.tanModalShown}
            customSendRequestTan={sendTan}
            customSendRequestData={this.customSendRequestData}
            onClickResendTan={trackRequestNewTan}
            onError={trackSubmitError}
            externalLinkExpiryMessage={false} // optional
            processResponse={this.processResponse}
          />
        )}
      </ContentSection>
    );
  };

  render() {
    if (this.props.expired) {
      return this.renderDataExpired();
    } else {
      return this.renderValidData();
    }
  }
}

type AuthenticationCodeRequestPageProps = {
  onTanSuccess: (prefilledData: any) => void;
  transactionId: string;
  prefill: any;
  expired: boolean;
  originSystem: string;
};

type AuthenticationCodeRequestPageState = {
  tanModalShown: boolean;
};

export { AuthenticationCodeRequestPage };
